import { useMutation } from "@tanstack/react-query";

import { useDepositUsdcConditional } from "./deposit-usdc-conditional";
import { useMintUsdc } from "./mint-usdc";

export function useMintAndDepositUsdc() {
  const { mutateAsync: mintUsdc } = useMintUsdc();
  const { mutateAsync: depositUsdcConditional } = useDepositUsdcConditional();

  return useMutation({
    mutationFn: async (amount: number) => {
      await mintUsdc(amount);
      await depositUsdcConditional({ amount });
    },
  });
}
